import { select } from '@pressreader/appstore';
import { getConfigValue } from '@pressreader/config';
import { cookies } from '@pressreader/utils';

import { selectInterfaceLanguageCode } from './store';

export function initCookieBot() {
    const cookieBotEnabled = getConfigValue<boolean>('features.cookiebot.enabled', true);

    if (!cookieBotEnabled || cookies.disabled()) {
        return;
    }

    const id = 'Cookiebot';
    let script: HTMLScriptElement = document.getElementById(id) as HTMLScriptElement;
    if (!script) {
        const langCode = select(selectInterfaceLanguageCode);
        script = document.createElement('script');
        script.id = id;
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://consent.cookiebot.com/uc.js';
        script.setAttribute('data-cbid', '06b589d2-9594-4323-af24-0b61ef0a0f2d');
        script.setAttribute('data-culture', langCode.split('-')[0]);
        document.head.insertBefore(script, document.head.firstChild);
    }
}
